import React from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { IconButton } from './IconButton'

export function Modal({
  title,
  trigger,
  confirm,
  children,
}: {
  title: string
  trigger: React.ReactNode
  confirm: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="pc-modal__overlay" />
        <Dialog.Content>
          <div className="fixed -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 z-50">
            <div className="w-fit min-w-[32rem] px-8 pt-6 pb-7 no-overflow rounded-2xl relative z-50 bg-primary">
              <Dialog.Title className="pc-modal__header__text mb-10">{title}</Dialog.Title>

              {children}

              <div className="flex flex-row justify-end gap-2 mt-10">
                <Dialog.Close asChild>
                  <button className="pc-button pc-button--gray-outline text-primary pc-button--sm py-2">Cancel</button>
                </Dialog.Close>

                <Dialog.Close asChild>{confirm}</Dialog.Close>
              </div>

              <Dialog.Close asChild>
                <div className="absolute top-3 right-4 group">
                  <IconButton
                    icon={<XMarkIcon className="w-6 h-6 icon-secondary group-hover:icon-primary" />}
                    screenReaderText="Close"
                  />
                </div>
              </Dialog.Close>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
